// スライドして表示非表示が切り替わるアニメーションの時間
export const SLIDE_TOGGLE_ANIMATION_DURATION = 500;
